/**
 * Single-credential ("simple") auth — the interim stopgap. Posts the shared
 * username + password to the API, which returns a short-lived session token we
 * store in the `token` cookie (then sent as `Authorization: Bearer` on /api/*).
 */
import { api } from "@/lib/api-client";
import { setTokenCookie } from "./cookies";

interface LoginResult {
  token: string;
  expiresAt: string;
  user: { sub: string; role: string; name?: string };
}

/**
 * Exchange credentials for a session token and persist it. Throws ApiError on
 * bad credentials (401) so the caller can surface a message.
 */
export async function loginWithPassword(username: string, password: string): Promise<LoginResult> {
  const result = await api.post<LoginResult>("/api/v1/auth/login", { username, password });
  const ttlMs = Math.max(0, new Date(result.expiresAt).getTime() - Date.now());
  setTokenCookie(result.token, ttlMs || undefined);
  return result;
}
